import type { EffectiveDated, LocalDate } from './types.js';

/**
 * The value in effect on `date`: the entry with the latest `effectiveFrom` on or before it. Entries need not be sorted;
 * when two share an `effectiveFrom`, the later one in the array wins. Dates before the first entry use the first
 * entry's value (history starts with the value a location was created or imported with). Empty history yields
 * `fallback`.
 */
export function resolveEffective<T>(history: readonly EffectiveDated<T>[], date: LocalDate, fallback: T): T {
  let best: EffectiveDated<T> | undefined;
  let earliest: EffectiveDated<T> | undefined;
  for (const entry of history) {
    if (entry.effectiveFrom <= date && (best === undefined || entry.effectiveFrom >= best.effectiveFrom)) best = entry;
    if (earliest === undefined || entry.effectiveFrom < earliest.effectiveFrom) earliest = entry;
  }
  return (best ?? earliest)?.value ?? fallback;
}
